import styled from 'styled-components';

export const DisclaimerWrapper = styled.div`
    background: ${({ theme }) => theme.Colors.Aliases.backgroundLight};
    
    &&& .accordion {
        border: none;
        margin-top: 1rem;
        margin-bottom: 0;
        
        .accordion-header {
            border: none;
            color: #1175B5;
            justify-content: left;
            padding: 0 1.5rem 1.5rem 0;
        }
        
        .accordion-content {
            padding: 0;
        }
        
        ul li {
            list-style: disc;
            margin-left: 1rem;
        }
    }    
`;

export const DisclaimerH2Wrapper = styled.h2`
&&& {
    font-size: 1rem;
}
`;
